import { AppThunk } from 'store';
import { NavigateFunction } from 'react-router-dom';
import { LoadAudioFunction, StopAudioFunction } from 'features/audio/audio';
import { loadEvent, unloadEvent } from 'thunks/navigationThunks';
import { broadcastForEventSelector } from 'features/broadcast/selectors';
import { EventModel } from './EventModel';
import { setAudioUrl } from 'features/audio/audioSlice';

export const navigateToEvent =
  (
    event: EventModel | null,
    loadAudio: LoadAudioFunction,
    stopAudio: StopAudioFunction,
    navigate: NavigateFunction,
    subscribeToBroadcast: (_: string) => void,
    isListenerAppWebView: boolean
  ): AppThunk =>
  async (dispatch, getState) => {
    if (!event) {
      return;
    }

    const broadcastForEvent = broadcastForEventSelector(getState(), event.id);

    const {
      channel: { miniPlayerVisible },
      hub: { isHubConnected },
      audio: { playing }
    } = getState();

    if (playing) {
      stopAudio(true);
    }

    dispatch(unloadEvent());

    if (miniPlayerVisible) {
      dispatch(loadEvent(event.id));
    } else {
      navigate(`/events/${event.id}`, {
        replace: true,
        state: { animate: false }
      });
    }

    if (broadcastForEvent) {
      dispatch(setAudioUrl(broadcastForEvent.url));
    }

    if (broadcastForEvent && isHubConnected) {
      subscribeToBroadcast(broadcastForEvent.uid);
    }

    if (broadcastForEvent && !isListenerAppWebView) {
      loadAudio({
        audioSrc: broadcastForEvent.url,
        autoPlay: true,
        audioType: 'event',
        withDelay: event.fallback
      });
    }
  };
